define('view/disclosure/document.list.action.buttons',['require','exports','module','marionette','uikit/uikit','blockit'],function (require, exports, module) {
    //prettier-ignore
    var Mn = require('marionette'),
        UIKit = require('uikit/uikit'),
        BlocKit = require('blockit');

    var DocumentListActionButtons = UIKit.ItemView.extend({
        template: function () {
            return '<ui name="fileButtonView" /><ui name="editButtonView" /><ui name="deleteButtonView" /><ui name="cancelButtonView" /><ui name="saveButtonView" />';
        },


        internalViewOptions: {


            fileButtonView: function () {
                return {
                    type: UIKit.Button.extend({
                        className: UIKit.Button.prototype.className + ' minimal',
                    }),
                    icon: 'download',
                    iconRight: true,
                    floated: true,
                    model: this.model,
                    color: 'primary',

                    onPress: function() {
                        var request = new XMLHttpRequest();
                        var url = this.model.virtual.urlForFiles.urlRoot  + this.model.get('id');

                        request.open(
                            'GET',
                            url
                        );
                        var authorization = 'Bearer '+ localStorage.getItem('fk_accessToken');
                        request.setRequestHeader('Authorization', authorization );
                        request.setRequestHeader('X-IDP-New-Login', true);
                        request.responseType = 'blob';

                        request.onload = function() {
                            if (request.status == 200) {
                                var blob;
                                if (request.getResponseHeader('content-type')) {
                                    blob = new Blob([request.response], {
                                        type: request.getResponseHeader('Content-Type'),
                                    });
                                } else {
                                    blob = new Blob([request.response], { type: 'text/plain' });
                                }

                                var a = document.createElement('a');
                                a.style.display = 'none';
                                var contentDisposition = request.getResponseHeader('content-disposition');
                                if (contentDisposition !== null && contentDisposition.indexOf('filename="') !== -1) {
                                    a.download = contentDisposition.split('"')[1];
                                } else {
                                    a.download = 'attachment';
                                }
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                document.body.appendChild(a);
                                a.click();
                                a = null;
                                window.open(url, '_blank');
                            }
                        };

                        request.send();
                    },


                    behaviors: {
                        hideWhenEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                visible: {
                                    formatter: function (model) {
                                        return !model.get('editMode');
                                    },
                                },
                            },
                        },

                    },
                };
            },

            editButtonView: function () {
                return {
                    type: UIKit.Button.extend({
                        className: UIKit.Button.prototype.className + ' minimal',
                    }),
                    icon: 'pencil',
                    iconRight: true,
                    floated: true,
                    model: this.model,
                    color: 'primary',
                    behaviors: {
                        hideWhenEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                visible: {
                                    formatter: function (model) {
                                        return !model.get('editMode');
                                    },
                                },
                            },
                        },
                        startEdit: {
                            behaviorClass: Mn.Behavior.extend({

                                onFirstBeforeRender: function () {

                                    this.view.model.set('editMode', false);

                                    this.listenTo(this.view, 'press', function () {
                                        //prettier-ignore
                                        var docModel = this.view.model;
                                        docModel.set('editMode', true);
                                    });
                                },
                            }),
                        },
                    },
                };
            },

            deleteButtonView: function () {
                return {
                    type: UIKit.Button.extend({
                        className: UIKit.Button.prototype.className + ' minimal',
                    }),
                    icon: 'trash',
                    iconRight: true,
                    floated: true,
                    model: this.model,
                    color: 'primary',
                    behaviors: {
                        hideWhenEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                visible: {
                                    formatter: function (model) {
                                        return !model.get('editMode');
                                    },
                                },
                            },
                        },
                        deleteFile: {
                            modalOptions: {
                                entityTypeText: 'Document',
                                entityText: 'this document, which will be removed from Cayuse COI completely',
                            },

                            behaviorClass: BlocKit.ConfirmModelDestroyOnEventBehavior,
                        },
                    },
                };
            },


            cancelButtonView: function () {
                return {
                    type: UIKit.Button,
                    className: UIKit.Button.prototype.className + ' cancel-button',
                    model: this.model,
                    text: 'Cancel',
                    size: 'mini',
                    visible: false,
                    behaviors: {
                        showWhenEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                visible: {
                                    formatter: function (model) {
                                        return model.get('editMode');
                                    },
                                },
                            },
                        },
                        cancelEdit: {
                            behaviorClass: Mn.Behavior.extend({

                                onFirstBeforeRender: function () {

                                    this.listenTo(this.view, 'press', function (options) {
                                        //prettier-ignore
                                        var docModel = this.view.model;
                                        docModel.set('editMode', false);
                                        // restore data
                                        var docCollection = this.view.model.collection;
                                        return docCollection
                                            .fetch()
                                            .promise()
                                            .then(function () {
                                                docCollection.trigger('change');
                                            })
                                            .catch(function(error) {
                                                console.error('An error occurred while fetching the document collection:', error);
                                            });

                                    });
                                },
                            }),
                        },
                    },
                };
            },


            saveButtonView: function () {
                return {
                    type: UIKit.Button,
                    className: UIKit.Button.prototype.className + ' save-button',
                    model: this.model,
                    text: 'Save',
                    color: 'primary',
                    size: 'mini',
                    disabled: false,
                    fitted: true,
                    onPress: function () {
                        var docModel = this.model;
                        var docCollection = this.model.collection;

                        docModel
                            .save(docModel.get('id'))
                            .promise()
                            .then(function () {
                                docCollection.forEach(function (doc) {
                                    doc.set('editMode', false);
                                });


                                return docCollection
                                    .fetch()
                                    .promise()
                                    .then(function () {
                                        docCollection.trigger('change');
                                    })
                                    .catch(function(error) {
                                        console.error('An error occurred while saving the document model:', error);
                                    });
                            });
                    },
                    behaviors: {
                        // Show the save button when we are in edit mode
                        showWhenEditMode: {
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                            optionValues: {
                                visible: {
                                    formatter: function (model) {
                                        return model.get('editMode');
                                    },
                                },
                            },
                        },
                        // prevent navigating from the page with unsaved changes
                        showModalOnNavigateWithUnsavedChangesBehavior: {
                            behaviorClass: BlocKit.ShowModalOnUnsavedChangesBehavior,
                        },
                    },
                };
            },
        },
    });
    module.exports = DocumentListActionButtons;
});

